import { createSvgIcon } from "@mui/material/utils";

/**
 * Add user icon.
 *
 * ![AddUserIcon](data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSItMi40IC0yLjQgMjQuOCAyMi44IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MCIgaGVpZ2h0PSIzNyIgc3R5bGU9ImJhY2tncm91bmQ6I2ZmZjtib3JkZXItcmFkaXVzOjRweCI+PHBhdGggZD0iTTE1LjgzMDcgMTYuNVYxMS41TTEzLjMzMDcgMTRIMTguMzMwN005Ljk5NzQgMTEuNUg2LjY2NDA2QzUuMTEwOTIgMTEuNSA0LjMzNDM1IDExLjUgMy43MjE3OCAxMS43NTM3QzIuOTA1MDIgMTIuMDkyIDIuMjU2MTEgMTIuNzQxIDEuOTE3OCAxMy41NTc3QzEuNjY0MDYgMTQuMTcwMyAxLjY2NDA2IDE0Ljk0NjkgMS42NjQwNiAxNi41TTEyLjkxNDEgMS43NDIzQzE0LjEzNTcgMi4yMzY3OSAxNC45OTc0IDMuNDM0NDMgMTQuOTk3NCA0LjgzMzMzQzE0Ljk5NzQgNi4yMzIyNCAxNC4xMzU3IDcuNDI5ODggMTIuOTE0MSA3LjkyNDM3TTExLjI0NzQgNC44MzMzM0MxMS4yNDc0IDYuNjc0MjggOS43NTUwMSA4LjE2NjY3IDcuOTE0MDYgOC4xNjY2N0M2LjA3MzExIDguMTY2NjcgNC41ODA3MyA2LjY3NDI4IDQuNTgwNzMgNC44MzMzM0M0LjU4MDczIDIuOTkyMzggNi4wNzMxMSAxLjUgNy45MTQwNiAxLjVDOS43NTUwMSAxLjUgMTEuMjQ3NCAyLjk5MjM4IDExLjI0NzQgNC44MzMzM1oiIHN0cm9rZT0iIzUxNTU1QyIgc3Ryb2tlLXdpZHRoPSIxLjY2NjY3IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPjwvcGF0aD48L3N2Zz4=)
 */
const AddUserIcon = createSvgIcon(
  <svg
    width="20"
    height="18"
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.8307 16.5V11.5M13.3307 14H18.3307M9.9974 11.5H6.66406C5.11092 11.5 4.33435 11.5 3.72178 11.7537C2.90502 12.092 2.25611 12.741 1.9178 13.5577C1.66406 14.1703 1.66406 14.9469 1.66406 16.5M12.9141 1.7423C14.1357 2.23679 14.9974 3.43443 14.9974 4.83333C14.9974 6.23224 14.1357 7.42988 12.9141 7.92437M11.2474 4.83333C11.2474 6.67428 9.75501 8.16667 7.91406 8.16667C6.07311 8.16667 4.58073 6.67428 4.58073 4.83333C4.58073 2.99238 6.07311 1.5 7.91406 1.5C9.75501 1.5 11.2474 2.99238 11.2474 4.83333Z"
      stroke="#51555C"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  "AddUser"
);

export default AddUserIcon;
